import PropTypes from 'prop-types';
import React from 'react';
import '../DistrictSummaryPage.scss';
import OfficeListColumnHeader from './OfficeListColumnHeader';
import OfficeListFilterHeader from './OfficeListFilterHeader';
import OfficeListNoResults from './OfficeListNoResults';
import OfficeListPages from './OfficeListPages';
import OfficeListSkeletonRow from './OfficeListSkeletonRow';
import OfficeListTableRow from './OfficeListTableRow';

const OfficeListTable = (props) => (
    <div id='queue-table'>
        <OfficeListFilterHeader {...props} />
        <OfficeListColumnHeader {...props} />
        {!props.officeList &&
            [...Array(10)].map((o, i) => <OfficeListSkeletonRow key={`osr_${i}`} />)
        }
        {props.officeList && props.officeList.resultCount === 0 &&
            <OfficeListNoResults />
        }
        {props.officeList && props.officeList.resultCount > 0 &&
            props.officeList.items.map((o, i) =>
                <OfficeListTableRow office={o} key={`otr_${i}`} {...props} />
            )
        }
        {props.officeList && props.officeList.totalCount > props.limit &&
            <OfficeListPages {...props} />
        }
    </div>
)

OfficeListTable.propTypes = {
    officeList: PropTypes.object,
    districtFilter: PropTypes.number,
    sort: PropTypes.string,
    limit: PropTypes.number.isRequired,
    onFilterChanged: PropTypes.func.isRequired,
    onSortChanged: PropTypes.func.isRequired,
    onSetOffset: PropTypes.func.isRequired,
    onOfficeClicked: PropTypes.func.isRequired
}

export default OfficeListTable